import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Skills  from "./components/Skills";
import Footer from "./components/Footer";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <div className="bg-primary min-h-screen text-slate-200 selection:bg-accent selection:text-white">
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/about" element={<About />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/skills" element={<Skills />} />

          </Routes>
          <Footer />
      </div>
    </BrowserRouter>
);
};

export default App;